import(/* webpackMode: "eager" */ "/app/app/pobeda/page.tsx");
